/**
 * @class
 */
import Base from '@netx/core/lib/netx-view';
import Template from '../templates/formErrorListItemView.html';

class FormErrorListItemView extends Base {
	/** @override */
	constructor(opts = {}) {
		opts.events = _.extend(
			{
				click: 'gotoInput',
			},
			opts.events,
		);
		opts.template = opts.template || Template;
		super(opts);
	}

	/**
	 * @method
	 * @param {event} e Click event
	 */
	gotoInput(e) {
		this.model.get('input').focus();
	}

	/** @type {string} */
	static get __name__() {
		return 'FormErrorListItemView';
	}
}

export default FormErrorListItemView;
